import { Col, Container, Row } from "react-bootstrap";
import ScrapeEntryForm from "../../../Components/Forms/ScrapeEntryForm/ScrapeEntryForm";
import { navigateTo } from "../../../redux/router/routerActions";
import { useAppDispatch } from "../../../redux/store";
import { useAddNewScrapeEntryMutation } from "../../../services/bClientApi";

export default function AddScrapeEntryPage() {

  const [
    addNewScrapeEntry,
    {
      isLoading,
      error
    }
  ] = useAddNewScrapeEntryMutation()

  const dispatch = useAppDispatch()
  const handleSubmit = async (data: any) => {
    const values: any = {
      ...data
    }
    const newScrapeEntry = await addNewScrapeEntry(values).unwrap()
    if (newScrapeEntry._id) {
      dispatch(navigateTo(`/scrape-entry/${newScrapeEntry._id}`))
    }
    return newScrapeEntry
  }

  return (
    <Container>
      <Row>
        <Col>
          <h1>Add Scrape Entry</h1>
          <hr />
          {error && (<>{JSON.stringify(error)}<br /></>)}

          <ScrapeEntryForm
            initialValues={{
                source: '',
                type: '',
                dataId: '',
                success: false,
                error: false,
                errorMessage: '',
                rawLines: [],
                parsedData: {},
            }}
            disabled={isLoading}
            onSubmit={handleSubmit}
          />

        </Col>
      </Row>
    </Container>
  )
}